import { GeoJsonLayer } from "@deck.gl/layers";
import { MVTLayer } from "@deck.gl/geo-layers";

export class SitesGeoJsonLayer extends GeoJsonLayer {}
export class SitesMvtLayer extends MVTLayer {}

SitesGeoJsonLayer.layerName = "SitesGeoJsonLayer";
SitesMvtLayer.layerName = "SitesMVTLayer";
